// extracted by mini-css-extract-plugin
module.exports = {"container":"g2","title":"g3"};